/* ============================================================
   Sample – Cart Drawer (AJAX)
   ============================================================ */
(function () {
  'use strict';

  function i18n(key, fallback) {
    return (window.sampleI18n && window.sampleI18n[key]) || fallback;
  }

  var SampleCart = {
    drawer: null, overlay: null, body: null, footer: null,

    init: function () {
      this.drawer  = document.getElementById('sample-cart-drawer');
      this.overlay = document.getElementById('sample-cart-overlay');
      this.body    = document.getElementById('cart-drawer-body');
      this.footer  = document.getElementById('cart-drawer-footer');
      if (!this.drawer) return;
      document.querySelectorAll('[data-cart-open]').forEach(function (el) {
        el.addEventListener('click', function () { SampleCart.open(); });
      });
      var closeBtn = document.getElementById('cart-drawer-close');
      if (closeBtn) closeBtn.addEventListener('click', function () { SampleCart.close(); });
      if (this.overlay) this.overlay.addEventListener('click', function () { SampleCart.close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') SampleCart.close(); });
      var pdpForm = document.getElementById('pdp-form');
      if (pdpForm) {
        pdpForm.addEventListener('submit', function (e) {
          e.preventDefault();
          SampleCart.addToCart(pdpForm);
        });
      }
      this.refreshCount();
    },

    open: function () {
      this.drawer.classList.add('is-open');
      this.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this.render();
    },

    close: function () {
      this.drawer.classList.remove('is-open');
      this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    },

    fetchCart: function () {
      return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } }).then(function (r) { return r.json(); });
    },

    fetchComparePrices: function (items) {
      var seen = {}, handles = [];
      items.forEach(function (item) {
        if (item.handle && !seen[item.handle]) { seen[item.handle] = true; handles.push(item.handle); }
      });
      var promises = handles.map(function (handle) {
        return fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (product) {
          var map = {};
          (product.variants || []).forEach(function (v) {
            if (v.compare_at_price && v.compare_at_price > v.price) map[v.id] = v.compare_at_price;
          });
          return map;
        }).catch(function () { return {}; });
      });
      return Promise.all(promises).then(function (maps) {
        var result = {};
        maps.forEach(function (m) { Object.keys(m).forEach(function (k) { result[k] = m[k]; }); });
        return result;
      });
    },

    refreshCount: function () {
      this.fetchCart().then(function (cart) { SampleCart.updateBadge(cart.item_count); }).catch(function () {});
    },

    updateBadge: function (count) {
      var badge = document.getElementById('cart-count-nav');
      if (!badge) return;
      badge.textContent = count > 99 ? '99+' : count;
      badge.classList.toggle('has-items', count > 0);
      var drawerCount = document.getElementById('cart-count-drawer');
      if (drawerCount) drawerCount.textContent = count;
    },

    render: function () {
      if (!this.body) return;
      this.body.innerHTML = '<div class="cart-drawer__loading">' + i18n('loading', 'Chargement…') + '</div>';
      if (this.footer) this.footer.style.display = 'none';
      this.fetchCart().then(function (cart) {
        SampleCart.updateBadge(cart.item_count);
        if (!cart.items || cart.items.length === 0) { SampleCart.renderItems(cart, {}); return; }
        SampleCart.fetchComparePrices(cart.items).then(function (comparePrices) { SampleCart.renderItems(cart, comparePrices); });
      }).catch(function () {
        SampleCart.body.innerHTML = '<div class="cart-drawer__loading">' + i18n('loadError', 'Erreur de chargement.') + '</div>';
      });
    },

    renderItems: function (cart, comparePrices) {
      comparePrices = comparePrices || {};
      if (!cart.items || cart.items.length === 0) {
        this.body.innerHTML = [
          '<div class="cart-drawer__empty">',
          '  <div class="cart-drawer__empty-icon">',
          '    <svg width="30" height="30" viewBox="0 0 30 30" fill="none">',
          '      <path d="M4 8h22l-3 14H7L4 8Z" stroke="#969492" stroke-width="1.5" stroke-linejoin="round"/>',
          '      <path d="M11 8V6a4 4 0 0 1 8 0v2" stroke="#969492" stroke-width="1.5" stroke-linecap="round"/>',
          '      <circle cx="11" cy="25" r="1.5" fill="#969492"/>',
          '      <circle cx="19" cy="25" r="1.5" fill="#969492"/>',
          '    </svg>',
          '  </div>',
          '  <p class="cart-drawer__empty-title">' + i18n('emptyTitle', 'Votre panier est vide') + '</p>',
          '  <p class="cart-drawer__empty-sub">' + i18n('emptySub', 'Découvrez nos ventes privées en exclusivité.') + '</p>',
          '  <a href="/" class="cart-drawer__empty-cta">' + i18n('viewSales', 'VOIR LES VENTES') + '</a>',
          '</div>'
        ].join('');
        if (this.footer) this.footer.style.display = 'none';
        return;
      }

      var totalSavings = 0;
      var brandCache = {};
      try { brandCache = JSON.parse(localStorage.getItem('sampleBrandCache') || '{}'); } catch(e) {}

      var html = cart.items.map(function (item) {
        var imgHTML = item.image ? '<img src="' + item.image + '" alt="' + SampleCart.esc(item.product_title) + '" class="cart-item__img">' : '';
        var vendorDisplay = (window.SampleBrandMap && window.SampleBrandMap[item.handle]) || brandCache[item.handle] || item.vendor;
        var vendorHTML = vendorDisplay ? '<p class="cart-item__vendor">' + SampleCart.esc(vendorDisplay) + '</p>' : '';
        var variantHTML = (item.variant_title && item.variant_title !== 'Default Title') ? '<p class="cart-item__variant">' + SampleCart.esc(item.variant_title) + '</p>' : '';
        var cp = parseInt(comparePrices[item.variant_id], 10) || 0;
        var fp = item.final_price || item.price;
        var compareHTML = '';
        if (cp > 0 && cp > fp) {
          compareHTML = '<span class="cart-item__compare">' + SampleCart.money(cp * item.quantity) + '</span>';
          totalSavings += (cp - fp) * item.quantity;
        }
        return [
          '<div class="cart-item" data-key="' + item.key + '" data-url="' + SampleCart.esc(item.url) + '">',
          '  <div class="cart-item__img-wrap">' + imgHTML + '</div>',
          '  <div class="cart-item__info">',
          '    ' + vendorHTML,
          '    <p class="cart-item__title">' + SampleCart.esc(item.product_title) + '</p>',
          '    ' + variantHTML,
          '    <div class="cart-item__bottom">',
          '      <div class="cart-item__qty">',
          '        <button class="cart-item__qty-btn" data-action="decrease" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="' + i18n('decrease','Diminuer') + '">−</button>',
          '        <span class="cart-item__qty-num">' + item.quantity + '</span>',
          '        <button class="cart-item__qty-btn" data-action="increase" data-key="' + item.key + '" data-qty="' + item.quantity + '" aria-label="' + i18n('increase','Augmenter') + '">+</button>',
          '      </div>',
          '      <div class="cart-item__right">',
          '        <div class="cart-item__prices">',
          '          ' + compareHTML,
          '          <span class="cart-item__price">' + SampleCart.money(item.final_line_price) + '</span>',
          '        </div>',
          '        <button class="cart-item__remove" data-key="' + item.key + '" aria-label="' + i18n('remove','Supprimer') + '">',
          '          <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M1.5 1.5l10 10M11.5 1.5l-10 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
          '        </button>',
          '      </div>',
          '    </div>',
          '  </div>',
          '</div>'
        ].join('');
      }).join('');

      this.body.innerHTML = html;

      this.body.querySelectorAll('.cart-item__qty-btn').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var key = btn.dataset.key;
          var qty = parseInt(btn.dataset.qty, 10);
          var newQty = btn.dataset.action === 'increase' ? qty + 1 : qty - 1;
          SampleCart.updateItem(key, newQty);
        });
      });

      this.body.querySelectorAll('.cart-item__remove').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          SampleCart.updateItem(btn.dataset.key, 0);
        });
      });

      this.body.querySelectorAll('.cart-item[data-url]').forEach(function (item) {
        item.style.cursor = 'pointer';
        item.addEventListener('click', function () { window.location.href = item.dataset.url; });
      });

      if (this.footer) {
        this.footer.style.display = 'block';
        var totalEl = document.getElementById('cart-drawer-total');
        if (totalEl) totalEl.textContent = SampleCart.money(cart.total_price);
        var savingsRow = document.getElementById('cart-drawer-savings');
        var savingsAmt = document.getElementById('cart-drawer-savings-amount');
        if (savingsRow && savingsAmt) {
          if (totalSavings > 0) {
            savingsAmt.textContent = '− ' + SampleCart.money(totalSavings);
            savingsRow.style.display = 'flex';
          } else {
            savingsRow.style.display = 'none';
          }
        }
      }
    },

    updateItem: function (key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        SampleCart.updateBadge(cart.item_count);
        if (!cart.items || cart.items.length === 0) { SampleCart.renderItems(cart, {}); return; }
        SampleCart.fetchComparePrices(cart.items).then(function (comparePrices) { SampleCart.renderItems(cart, comparePrices); });
      }).catch(function () {});
    },

    addToCart: function (form) {
      var btn = form.querySelector('.pdp-atc');
      var variantId = form.querySelector('[name="id"]').value;
      var quantity = parseInt((form.querySelector('[name="quantity"]') || {}).value || '1', 10);
      if (btn) {
        btn.disabled = true;
        var originalText = btn.textContent;
        btn.textContent = i18n('adding', 'AJOUT…');
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: quantity })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Erreur'); });
        return r.json();
      }).then(function () {
        SampleCart.refreshCount();
        SampleCart.open();
      }).catch(function (e) {
        alert(e.message || i18n('addError', "Impossible d'ajouter ce produit."));
      }).finally(function () {
        if (btn) {
          btn.disabled = false;
          btn.textContent = originalText || i18n('addToCart', 'AJOUTER AU PANIER');
        }
      });
    },

    money: function (cents) {
      return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
    },

    esc: function (str) {
      return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { SampleCart.init(); });
  } else {
    SampleCart.init();
  }
})();
